"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doLogin = exports.SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = void 0;
var _goToPage = require("./goToPage");
const SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_LOGIN_PATH = '/ssoidentity/Login';
const SSO_IDENTITY_AD_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = `${SSO_IDENTITY_LOGIN_PATH}?ssoLoginType=ActiveDirectory`;
const doLogin = event => {
  // Ctrl or Cmd key is pressed, redirect to AD login
  if (Boolean(event?.ctrlKey) || event?.metaKey) {
    (0, _goToPage.goToPage)(SSO_IDENTITY_AD_LOGIN_PATH);
    return;
  }
  (0, _goToPage.goToPage)(SSO_IDENTITY_LOGIN_PATH);
};
exports.doLogin = doLogin;
//# sourceMappingURL=doLogin.js.map